<template>
  <div>
    <v-data-table :page.sync="page" @page-count="pageCount = $event" :items="roles" :headers="headers"
      hide-default-footer>
      <template v-slot:[`item.id`]="{ item }">
        <span class="table-tutor-srno">{{ item.id }}</span>
      </template>

      <template v-slot:[`item.display_name`]="{ item }">
        <span class="table-tutor-srno">{{ item.display_name }}</span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <router-link class="profile-link" active-class :exact="true"
          :to="{ name: 'EditRole', params: { id: item.id } }">
          <v-icon color="success">mdi-file-edit</v-icon>
        </router-link>
        <v-icon color="red" @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <delete-dialog @success="deleteRole" :confirm-loading="deleteConfirmLoading" @closeDialog="cancelDelete"
      :dialog="delete_dialog" title="Role"></delete-dialog>
    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Roles
        <span :style="{ color: this.$vuetify.theme.themes.light.primary }">{{
            roles.length
        }}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>

import DeleteRow from '../../mixins/deleteRow';
import DeleteDialog from '../Dialogs/DeleteDialog.vue';
import DataTableMixin from '../../mixins/dataTable';

export default {
  name: "RolesTable",
  components: {
    DeleteDialog,
  },
  mixins: [DataTableMixin, DeleteRow],

  data() {
    return {
      page: 1,
      data: {},
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        {
          text: "Sr #.",
          sortable: true,
          value: "id",
        },
        {
          text: "Role",
          value: "display_name",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
      roles: [],
    };
  },

  methods: {
    deleteRole() {
      this.deleteConfirmLoading = true;
      axios.delete(apiRoutes.roles.deleteRole + "/" + this.current_row.id)
        .then((response) => {
          this.getItems();
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.delete_dialog = false;
        })
    },
    getItems() {
      this.loading = true;
      axios
        .get(apiRoutes.roles.getRoles)
        .then((response) => {
          this.loading = false;
          this.roles = response.data;
        }).catch((error) => {
          console.log(error);
        })
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-tutor {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-session {
    font: 500 14px/13px Gotham;
    color: #f0cb00;
  }

  &-date {
    font: 500 13px/13px Gotham;
    color: #0ebddff7;
  }
}

.v-btn.v-size--default {
  font-size: 12px;
  text-transform: none;
}
</style>
